import React, { useState } from 'react';

import styled, { css } from 'styled-components';
//import MemberTable from '../common/MemberTable';
import { Ring } from 'react-awesome-spinners';
import CommenButton from '../common/Button';
import { selectMainMembershipState, selectMainMembership, timeValueToDate, sort, sortReverse, inputNumberAutoComma } from '../../lib/commonFunc/commonFunc'
import Select from 'react-select';
import palette from '../../lib/styles/palette';
import Pagination from '@material-ui/lab/Pagination';
import { GoSearch } from 'react-icons/go';
import { MdRefresh, MdSmartphone } from 'react-icons/md';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import TextField from '@material-ui/core/TextField';

const Wrapper = styled.div`
  margin-top: 24px;
  padding-bottom: 40px;
`;

const Table = styled.table`
  font-family: 'Noto Sans KR', sans-serif;
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;

  th, td {
    border: 1px solid #e0e4ea;
    padding: 8px 12px;
    text-align: center;
  }

  thead th, thead td {
    background: #f5f7fa;
    font-weight: 700;
    color: #2c3e50;
    white-space: nowrap;
  }

  tbody td {
    color: #555;
  }

  tbody tr:hover {
    background: #f9fbfd;
  }
`;

const TextSpace = styled.div`
  display: flex;
  align-items: center;
  padding: 0 12px;
  font-size: 1.25rem;
  color: #868e96;
`;

const DateBlock = styled.td`
  padding: 10px;
  font-weight: 600;
`;
const Line = styled.div`
    width: 100%;
    margin-top: 40px;
`;
const TabBlock = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 24px;
  border-bottom: 1px solid #e0e4ea;
`;
const TabText = styled.div`
  font-size: 1rem;
  font-weight: 600;
  color: #868e96;
  cursor: pointer;
  padding: 12px 20px;
  border-bottom: 2px solid transparent;
  transition: all 0.15s ease;

  &:hover {
    color: ${palette.webCyan[5]};
  }

  ${(props) =>
        props.active &&
        css`
      font-weight: 700;
      color: ${palette.webCyan[5]};
      border-bottom-color: ${palette.webCyan[5]};
    `}
`;

const SectionWrapper = styled.div`
  margin-bottom: 32px;
  background: #fff;
  border: 1px solid #e0e4ea;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
`;

const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 24px;
  background: #f8f9fb;
  border-bottom: 1px solid #e0e4ea;
`;

const SectionTitle = styled.h3`
  font-size: 1.15rem;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
`;

const SectionBody = styled.div`
  padding: 24px;
`;

const FilterBar = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  padding: 20px 24px;
  margin-bottom: 24px;
  background: #f8f9fb;
  border: 1px solid #e0e4ea;
  border-radius: 12px;
`;

const SummaryBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 12px;
  margin-bottom: 20px;
`;

const SummaryItem = styled.div`
  flex: 1;
  min-width: 200px;
  max-width: 260px;
  padding: 14px 18px;
  background: #f8f9fb;
  border: 1px solid #e0e4ea;
  border-radius: 12px;
  font-size: 0.95rem;
  color: #555;

  strong {
    display: block;
    margin-top: 6px;
    font-size: 1.15rem;
    font-weight: 700;
    color: #2c3e50;
  }
`;

const FilterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;

  label {
    font-size: 0.9rem;
    font-weight: 600;
    color: #2c3e50;
  }
`;
const downloadExcel = (date, tableName) => {
    const table = document.getElementsByClassName(tableName)[0];
  
    let tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
    tab_text +=
      '<head><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">';
    tab_text += '<xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>';
    tab_text += '<x:Name>Test Sheet</x:Name>';
    tab_text +=
      '<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>';
    tab_text += '</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>';
    tab_text += "<table border='1px'>";
  
    let exportTable = table.cloneNode(true);
  
    tab_text += exportTable.outerHTML;
    tab_text += '</table></body></html>';
    let data_type = 'data:application/vnd.ms-excel';
    let ua = window.navigator.userAgent;
    let msie = ua.indexOf('MSIE ');
    let fileName = date + '_Table' + '.xls';
  
    // browser 처리
    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
      //ie 용
      if (window.navigator.msSaveBlob) {
        let blob = new Blob([tab_text], {
          type: 'application/csv;charset=utf-8;',
        });
        navigator.msSaveBlob(blob, fileName);
      }
    } else {
      //그외
      let blob2 = new Blob([tab_text], {
        type: 'application/csv;charset=utf-8;',
      });
      let filename = fileName;
      let elem = window.document.createElement('a');
      elem.href = window.URL.createObjectURL(blob2);
      elem.download = filename;
      document.body.appendChild(elem);
      elem.click();
      document.body.removeChild(elem);
    }
};

const AdminClubTransferMoney = ({
    transferLogList,
    transferClubLogList
}) => {

    const [clubfilter, setclubfilter] = useState(0)
    const [datefilter, setdatefilter] = useState({startTime:0, endTime:0})
    const [activeType, setActiveType] = useState('total')

    // 클럽번호 오름차순, 같은 클럽은 이체 실행일 최신순
    const sortedClubLogList = [...(transferClubLogList || [])].sort((a, b) =>
        (Number(a.clubID) || 0) - (Number(b.clubID) || 0) || (b.registTime || 0) - (a.registTime || 0)
    );

    let clubList = [{label:'전체', value:0}];

    for (let i = 0; i < sortedClubLogList.length; i++) {
        let skip = false;
        for (let j = 0; j < clubList.length; j++) {
            if(clubList[j].value == sortedClubLogList[i].clubID)
            {
                skip = true;
                break;
            }
        }

        if(!skip)
        {
            clubList.push({label:sortedClubLogList[i].clubName, value:sortedClubLogList[i].clubID});
        }
    }

    let dateList = [
        {label:'전체', value:{startTime:0, endTime:0}}
    ]
    let today = new Date(Date.now())
    today.setHours(0,0,0,0)
    today.setDate(1)
    let startTime = Number(today.getTime()/1000)
    today.setMonth(today.getMonth()+1)
    today.setDate(today.getDate()-1)
    let endTime = Number(today.getTime()/1000)
    dateList.push({label:`${today.getMonth()+1}월`, value:{endTime, startTime}})

    today.setDate(1)
    for (let i = 0; i < 11; i++) {
        endTime = Number(today.getTime()/1000)
        today.setMonth(today.getMonth() - 1)
        startTime = Number(today.getTime()/1000)
        dateList.push({label:`${today.getMonth()+1}월`, value:{endTime, startTime}})
    }

    let total_totalPrice = 0
    let total_fees = 0
    let total_transferPrice = 0

    for (let i = 0; i < transferClubLogList.length; i++) {
        const element = transferClubLogList[i];
        
        if(clubfilter != 0 && transferClubLogList[i].clubID != clubfilter)
        {
            continue;
        }

        if(datefilter.startTime != 0 && (transferClubLogList[i].registTime < datefilter.startTime || transferClubLogList[i].registTime > datefilter.endTime) )
        {
            continue;
        }

        total_totalPrice += transferClubLogList[i].totalPrice
        total_fees += transferClubLogList[i].fees
        total_transferPrice += transferClubLogList[i].transferPrice
    }


    let total_trans_totalPrice = 0
    let total_trans_fees = 0
    let total_trans_transferPrice = 0
    for (let i = 0; i < transferLogList.length; i++) {

        if(datefilter.startTime != 0 && (transferLogList[i].registTime < datefilter.startTime || transferLogList[i].registTime > datefilter.endTime) )
        {
            continue;
        }

        total_trans_totalPrice += transferLogList[i].totalPrice
        total_trans_fees += transferLogList[i].fees
        total_trans_transferPrice += transferLogList[i].transferPrice
    }

    const onClickPeriod = (period)=>{
        let tempdate = new Date()

        let startTime = 0;
        let endTime = parseInt(tempdate.getTime()/1000);
        if(period == 'month')
        {
            tempdate.setDate(1)
            tempdate.setHours(0, 0, 0, 0)
            startTime = parseInt(tempdate.getTime()/1000);
        }
        else if(period == '3months')
        {
            tempdate.setDate(1)
            tempdate.setHours(0, 0, 0, 0)
            tempdate.setMonth(tempdate.getMonth() - 2)
            startTime = parseInt(tempdate.getTime()/1000);
        }
        else if(period == '6months')
        {
            tempdate.setDate(1)
            tempdate.setHours(0, 0, 0, 0)
            tempdate.setMonth(tempdate.getMonth() - 5)
            startTime = parseInt(tempdate.getTime()/1000);
        }
        
        setdatefilter({startTime, endTime})
    }

    if(datefilter.startTime == 0 && datefilter.endTime == 0)
    {
        onClickPeriod('6months')
    }

    const changeDateFormat = (timestamp) => {
        const date = new Date(timestamp * 1000);
        const year1 = date.getFullYear();
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const day = ('0' + date.getDate()).slice(-2);
        const dateStr = `${year1}-${month}-${day}`;

        return dateStr
    }
    
  return (
    <Wrapper>
        <TabBlock >
            <div style={{ display: 'flex' }}>
                <TabText
                    onClick={() => setActiveType('total')}
                    active={activeType === 'total'}
                >
                    전체
                </TabText>
                <TabText
                    onClick={() => setActiveType('club')}
                    active={activeType === 'club'}
                >
                    클럽별
                </TabText>
            </div>
        </TabBlock>
        {
            activeType === 'total'?
            <div>
                <FilterBar>

                    <TextField
                        id="startTime"
                        label="시작일"
                        name="startTime"
                        type="date"
                        value={changeDateFormat(datefilter.startTime)}
                        onChange={(e) =>{
                            let date = new Date(e.target.value)

                            date.setHours(0, 0, 0, 0)

                            setdatefilter({startTime:parseInt(date.getTime()/1000), endTime:datefilter.endTime})
                        }}
                        InputLabelProps={{
                            shrink: true,
                    }}
                    />
                    <TextSpace>~</TextSpace>
                    <TextField
                        id="endTime"
                        label="종료일"
                        name="endTime"
                        type="date"
                        value={changeDateFormat(datefilter.endTime)}
                        onChange={(e) =>{
                            let date = new Date(e.target.value)

                            date.setHours(23, 59, 59)

                            setdatefilter({startTime:datefilter.startTime, endTime:parseInt(date.getTime()/1000)})
                        }}
                        InputLabelProps={{
                            shrink: true,
                    }}
                    />
                    <div style={{width:'20px'}}/>
                    <ButtonGroup
                        color="primary"
                        aria-label="outlined primary button group"
                    >
                        <Button onClick={() => onClickPeriod('month')}>1달</Button>
                        <Button onClick={() => onClickPeriod('3months')}>3달</Button>
                        <Button onClick={() => onClickPeriod('6months')}>6달</Button>
                        <Button onClick={() => onClickPeriod('')}>전체</Button>
                    </ButtonGroup>
                </FilterBar>
                <SectionWrapper>
                    <SectionHeader>
                        <SectionTitle>전체 이체 결과</SectionTitle>
                        <CommenButton
                            onClick={() => downloadExcel('전체 이체 결과', 'transferLogList')}
                        >{`Excel 다운로드`}</CommenButton>
                    </SectionHeader>
                    <SectionBody>
                    <SummaryBar>
                        <SummaryItem>총 결제 금액 : {inputNumberAutoComma(total_trans_totalPrice)}</SummaryItem>
                        <SummaryItem>총 수수료 : {inputNumberAutoComma(total_trans_fees)}</SummaryItem>
                        <SummaryItem>총 이체 금액 : {inputNumberAutoComma(total_trans_transferPrice)}</SummaryItem>
                    </SummaryBar>
                <Table className="transferLogList">
                    <thead>
                        <tr>
                        <td>이체 실행일</td>
                        <td>결제 기간</td>
                        <td>결제 금액</td>
                        <td>수수료</td>
                        <td>이체 금액</td>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            transferLogList.map((dateData, idx1)=>{
                                if(dateData.registTime < datefilter.startTime || dateData.registTime > datefilter.endTime)
                                {
                                    return null
                                }
                                return (
                                <tr
                                    key={idx1}
                                >
                                    <td>{dateData.registDate}</td>
                                    <td>{dateData.transferDateLangth}</td>
                                    <td>{inputNumberAutoComma(dateData.totalPrice)}</td>
                                    <td>{inputNumberAutoComma(dateData.fees)}</td>
                                    <td>{inputNumberAutoComma(dateData.transferPrice)}</td>
                                </tr>
                                )
                            })
                        }
                    </tbody>
                </Table>
                    </SectionBody>
                </SectionWrapper>
            </div>
            :
            activeType == 'club'?
            <div>
                <FilterBar>
                    <TextField
                        id="startTime"
                        label="시작일"
                        name="startTime"
                        type="date"
                        value={changeDateFormat(datefilter.startTime)}
                        onChange={(e) =>{
                            let date = new Date(e.target.value)

                            date.setHours(0, 0, 0, 0)

                            setdatefilter({startTime:parseInt(date.getTime()/1000), endTime:datefilter.endTime})
                        }}
                        InputLabelProps={{
                            shrink: true,
                    }}
                    />
                    <TextSpace>~</TextSpace>
                    <TextField
                        id="endTime"
                        label="종료일"
                        name="endTime"
                        type="date"
                        value={changeDateFormat(datefilter.endTime)}
                        onChange={(e) =>{
                            let date = new Date(e.target.value)

                            date.setHours(23, 59, 59)

                            setdatefilter({startTime:datefilter.startTime, endTime:parseInt(date.getTime()/1000)})
                        }}
                        InputLabelProps={{
                            shrink: true,
                    }}
                    />
                    <div style={{width:'20px'}}/>
                    <ButtonGroup
                        color="primary"
                        aria-label="outlined primary button group"
                    >
                        <Button onClick={() => onClickPeriod('month')}>1달</Button>
                        <Button onClick={() => onClickPeriod('3months')}>3달</Button>
                        <Button onClick={() => onClickPeriod('6months')}>6달</Button>
                        <Button onClick={() => onClickPeriod('')}>전체</Button>
                    </ButtonGroup>
                </FilterBar>
                <FilterRow>
                        <label>클럽 : </label>
                        <Select
                            options={clubList}
                            onChange={(e)=>{
                                setclubfilter(e.value)
                            }}
                            defaultValue={0}
                            isSearchable={false}
                            //style={{width:'250px'}}
                            styles={{
                                container: provided => ({...provided, width: '400px', padding: 0, border: 0}),
                                control: (provided, state) => ({
                                    ...provided,
                                    minHeight: '44px',
                                    borderRadius: '6px',
                                    borderColor: state.isFocused ? palette.webCyan[5] : '#CDD9ED',
                                    boxShadow: 'none',
                                    '&:hover': { borderColor: palette.webCyan[5] },
                                }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#f9fbfd' : '#fff',
                                    color: '#2c3e50',
                                }),
                            }}
                            height="450px"
                            aria-labelledby="select"
                            placeholder="클럽 선택"
                            maxMenuHeight={'450px'}
                        />
                        {/* <div style={{width: '50px', marginLeft:'50px'}}>기간 : </div>
                        <Select
                            options={dateList}
                            onChange={(e)=>{
                                setdatefilter(e.value)
                            }}
                            defaultValue={{startTime:0, endTime:0}}
                            isSearchable={false}
                            //style={{width:'250px'}}
                            styles={{ 
                                container: provided => ({...provided, width: '400px', padding: 0, border: 0})
                            }}
                            height="450px"
                            aria-labelledby="select"
                            placeholder="기간 선택"
                            maxMenuHeight={'450px'}
                        /> */}
                </FilterRow>
                <SectionWrapper>
                    <SectionHeader>
                        <SectionTitle>클럽별 이체 결과</SectionTitle>
                        <CommenButton
                            onClick={() => downloadExcel('클럽별 이체 결과', 'transferClubLogList')}
                        >{`Excel 다운로드`}</CommenButton>
                    </SectionHeader>
                    <SectionBody>
                    <SummaryBar>
                        <SummaryItem>총 결제 금액 : {inputNumberAutoComma(total_totalPrice)}</SummaryItem>
                        <SummaryItem>총 수수료 : {inputNumberAutoComma(total_fees)}</SummaryItem>
                        <SummaryItem>총 이체 금액 : {inputNumberAutoComma(total_transferPrice)}</SummaryItem>
                    </SummaryBar>
                <Table className="transferClubLogList">
                    <thead>
                        <tr>
                        <td>클럽번호</td>
                        <td>클럽 이름</td>
                        <td>이체 실행일</td>
                        <td>결제 기간</td>
                        <td>결제 금액</td>
                        <td>수수료</td>
                        <td>이체 금액</td>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            sortedClubLogList.map((dateData, idx1)=>{
                                if(clubfilter != 0 && dateData.clubID != clubfilter) return null;

                                if(datefilter.startTime != 0 && 
                                    (dateData.registTime < datefilter.startTime || dateData.registTime > datefilter.endTime) ) return null;
                                return (
                                <tr
                                    key={idx1}
                                >
                                    <td>{dateData.clubID}</td>
                                    <td>{dateData.clubName}</td>
                                    <td>{dateData.registDate}</td>
                                    <td>{dateData.transferDateLangth}</td>
                                    <td>{inputNumberAutoComma(dateData.totalPrice)}</td>
                                    <td>{inputNumberAutoComma(dateData.fees)}</td>
                                    <td>{inputNumberAutoComma(dateData.transferPrice)}</td>
                                </tr>
                                )
                            })
                        }
                    </tbody>
                </Table>
                    </SectionBody>
                </SectionWrapper>
            </div>
            :null
        }
        <Line/>
    </Wrapper>
  );
};

export default React.memo(AdminClubTransferMoney);
